import React, { Fragment, useEffect } from 'react'
import EditBtn from '../../buttons/EditBtn'
import DeleteBtn from '../../buttons/DeleteBtn'
import NullMssg from '../../common/NullMssg'
import Spinner from '../../common/Spinner'
import { NoInfo } from '../../common/NoInfo'
import { mssgs } from '../../../constantes/mssgs'

/**
 * Recuento de la cabecera. Los tres datos son distintos y los tres importan:
 *
 *   872 productos · 47 coincidencias · mostrando 20
 *    │                │                 └ cuántos hay cargados ahora mismo
 *    │                └ cuántos casan con la búsqueda
 *    └ cuántos hay en total, el universo sobre el que se busca
 *
 * Todo es opcional. El motor antiguo no conoce ninguno de esos números, así
 * que sin ellos se muestra exactamente el texto de siempre.
 */
const textoRecuento = (cargados, total, totalGeneral, filtrando, sustantivo) => {
  if (total === undefined || total === null) return `${cargados} resultados.`

  const partes = [
    totalGeneral !== undefined && totalGeneral !== null
      ? `${totalGeneral} ${sustantivo}`
      : null,
    filtrando ? `${total} coincidencias` : null,
    cargados < total ? `mostrando ${cargados}` : null,
  ].filter(Boolean)

  return partes.length ? partes.join(' · ') : `${total} resultados.`
}

const FinalProductsTable = ({
  handleRemove,
  toEditArticle,
  finalProducts,
  userProfile,
  loading,
  total,
  totalGeneral,
  filtrando,
}) => {
  useEffect(() => {}, [finalProducts])

  return (
    <>
      <div
        className='products__title__container mb-30'
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <h3 className='products__title'>Productos finales</h3>
        <span className='products__title__count-results'>
          {textoRecuento(
            finalProducts?.length,
            total,
            totalGeneral,
            filtrando,
            'productos',
          )}
        </span>
      </div>
      <Fragment>
        <div className='table-wrapper'>
          <table className='products-table'>
            <thead>
              <tr>
                <th className="table-th-code">
                  Referencia
                </th>
                <th>
                  Nombre
                </th>
                <th>
                  Categoría producto
                </th>
                <th>
                  Família del producto
                </th>
                <th className="table-th-doccount">
                  Port.
                </th>
                <th className="table-th-doccount">
                  Imgs.
                </th>
                <th className="table-th-doccount">
                  Docs.
                </th>
                <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                    Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              {finalProducts.length > 0 ? (
                finalProducts.map((product, i) => (
                  <tr key={i}>
                    <td>
                      {product.referencia}
                    </td>
                    <td className="table-td-header">
                      {product.nombre}
                    </td>
                    <td>
                      {product.nombreCategoria}
                      {/* Las adicionales, si las hay. El motor antiguo no
                          conoce este campo, así que allí no se pinta nada. */}
                      {product.categoriasAlternativas &&
                      product.categoriasAlternativas.length > 0 ? (
                        <div
                          style={{ fontSize: 11.5, opacity: 0.7, marginTop: 2 }}
                          title={`También en:\n${product.categoriasAlternativas.join('\n')}`}
                        >
                          + {product.categoriasAlternativas.join(', ')}
                        </div>
                      ) : null}
                    </td>
                    <td>
                      {product.nombrePadreProducto !== ''
                        ? product.nombrePadreProducto
                        : NoInfo('Sin Família')}
                    </td>
                    <td
                      className="table-td-doccount"
                      title={product?.cover ? `Portada:\n\n\t${product?.cover}\n.` : undefined}
                    >
                        {product.coverCount > 0 ? product.coverCount : ''}
                    </td>
                    <td
                      className="table-td-doccount"
                      title={product?.images?.length > 0 ? `Documentos:\n\n ${product?.images?.map((img) => "\t * " + img).join('\n')}\n.` : undefined}
                    >
                        {product.imageCount > 0 ? product.imageCount : ''}
                    </td>
                    <td
                      className="table-td-doccount"
                      title={product?.documents?.length > 0 ? `Documentos:\n\n ${product?.documents?.map((doc) => "\t * " + doc).join('\n')}\n.` : undefined}
                    >
                        {product.documentCount > 0 ? product.documentCount : ''}
                    </td>
                    <td className="table-td-actions">
                          <button
                            onClick={() => toEditArticle(product.id_Articulo)}
                          >
                            <EditBtn />
                          </button>
                          <button
                            onClick={() => handleRemove(product.id_Articulo)}
                          >
                            <DeleteBtn />
                          </button>
                    </td>
                  </tr>
                ))
              ) : (
                // colSpan debe coincidir con el número de <th> de arriba (8).
                // Y el <td> tiene que ir dentro de un <tr>: colgándolo de
                // <tbody> el HTML es inválido y el navegador lo recoloca,
                // que es por lo que no quedaba centrado.
                <tr>
                  <td colSpan={8} style={{ textAlign: 'center', padding: '28px 0' }}>
                    {loading ? (
                      <Spinner bloque />
                    ) : (
                      <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_PRODUCTOS} />
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Fragment>
    </>
  )
}

export default FinalProductsTable
